import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import MiniWidgets from "./MiniWidgets";
import RevenueAnalytics from "./RevenueAnalytics";
import SalesAnalytics from "./SalesAnalytics";
import EarningReports from "./EarningReports";
import { FetchServiceFees as fetchDashboardStatsApi } from "../../apis/Dashboard";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Nazox", link: "/" },
        { title: "Dashboard", link: "#" },
      ],
      reports: [
        {
          icon: "ri-user-line",
          title: "Total Users",
          value: "0", // Initial placeholder value
          rate: "2.4%",
          desc: "From previous period",
        },
        {
          icon: "ri-stack-line",
          title: "Total Listings",
          value: "0", // Initial placeholder value
          rate: "2.4%",
          desc: "From previous period",
        },
        {
          icon: "ri-store-2-line",
          title: "Total Reservations",
          value: "0", // Initial placeholder value
          rate: "2.4%",
          desc: "From previous period",
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchDashboardStats();
  }

  fetchDashboardStats = async () => {
    try {
      const response = await fetchDashboardStatsApi();

      if (response && response.data?.success) {
        const { totalUsers } = response.data?.data?.users;
        const { totalListings } = response.data?.data?.listings;
        const { totalReservations } = response.data?.data?.reservations;

        // Update reports with dynamic data
        this.setState({
          reports: [
            {
              icon: "ri-user-line",
              title: "Total Users",
              value: totalUsers,
              rate: "2.4%",
              desc: "From previous period",
            },
            {
              icon: "ri-stack-line",
              title: "Total Listings",
              value: totalListings,
              rate: "2.4%",
              desc: "From previous period",
            },
            {
              icon: "ri-store-2-line",
              title: "Total Reservations",
              value: totalReservations,
              rate: "2.4%",
              desc: "From previous period",
            },
          ],
        });
      } else {
        console.error(
          "Failed to fetch dashboard stats:",
          response?.data?.message,
        );
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid className="px-4">
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col xl={8}>
                <Row>
                  <MiniWidgets reports={this.state.reports} />
                </Row>
                <RevenueAnalytics />
              </Col>
              <Col xl={4}>
                <SalesAnalytics />
                <EarningReports />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Dashboard;
